import { RouterProvider } from "react-router-dom";
import AuthProvider, { CheckLoginUser } from "../context/auth/auth.provider";
import router from "../router/router";
import { AuthInterceptor } from "../api/axios";
import { memo, useState } from "react";
import Toaster from "../component/Notifications/toaster";

function RebliePages() {
  AuthInterceptor();
  CheckLoginUser();
  const [informUpdate, setInformUpdate] = useState(
    localStorage.getItem("inform-update")
  );

  const handleClose = () => {
    localStorage.setItem("inform-update", true);
    setInformUpdate(true);
  };

  return (
    <AuthProvider>
      {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}> */}
      <RouterProvider router={router} />
      <Toaster />
      {/* </GoogleReCaptchaProvider> */}
    </AuthProvider>
  );
}

export default memo(RebliePages);
